import { render, staticRenderFns } from "./client-gnb.vue?vue&type=template&id=96c763fa&scoped=true&"
import script from "./client-gnb.vue?vue&type=script&lang=js&"
export * from "./client-gnb.vue?vue&type=script&lang=js&"
import style0 from "./client-gnb.vue?vue&type=style&index=0&id=96c763fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c763fa",
  null
  
)

export default component.exports